import api from "../api"

export const ACTION_TYPES = {
    CLEAN_USER_PROFILE: 'CLEAN_USER_PROFILE',
    FETCH_STATUS: 'FETCH_STATUS',
    FETCH_CONTRACT_SERVICE_CODE: 'FETCH_CONTRACT_SERVICE_CODE',
    FETCH_SUPPLIER_BY_ID: 'FETCH_SUPPLIER_BY_ID'
}

export const fetch_supplier_by_id = (lang, token, supplierId, onError, success) => dispatch => {
    api.Catalogs().fetchSupplierById(lang, token, supplierId)
        .then(response => {
            dispatch({
                type: ACTION_TYPES.FETCH_SUPPLIER_BY_ID,
                payload: response.data
            })
            success(response.data)
        })
        .catch(err => onError(err))
}

export const fetch_status = (success, quadrant) => dispatch => {
    const listStatus = [
        {id: 1, description: 'Asignada'},
        {id: 4, description: 'Documentación rechazada'},
        {id: 2, description: 'En proceso'},
        {id: 3, description: quadrant === 'AdvanceOrder' ? 'Conciliada': 'Pagada' },
        {id: 5, description: 'Rechazada'},
    ];
    dispatch({
        type: ACTION_TYPES.FETCH_STATUS,
        payload: listStatus
    })
    success(listStatus)
}

export const fetch_contract_service_code = (lang, token, supplierId,onError, success) => dispatch => {
    api.Catalogs().fetchContractServiceCode(lang, token, supplierId)
        .then(response => {
            dispatch({
                type: ACTION_TYPES.FETCH_CONTRACT_SERVICE_CODE,
                payload: response.data
            })
            success(response.data)
        })
        .catch(err => onError(err))
}
